var _classCallCheck = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/lib/jenkins/workspace/deploy-prod-frontend/frontend_src_repo/frontend-v1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var DIRECTORY_TREE_ENTRY_TYPE_EMPTY = 0; // eslint-disable-line no-unused-vars
var DIRECTORY_TREE_ENTRY_TYPE_STORAGE = 1;
var DIRECTORY_TREE_ENTRY_TYPE_STREAM = 2;
var DIRECTORY_TREE_ENTRY_TYPE_ROOT = 5;
var DIRECTORY_TREE_NODE_COLOR_RED = 0; // eslint-disable-line no-unused-vars
var DIRECTORY_TREE_NODE_COLOR_BLACK = 1; // eslint-disable-line no-unused-vars

var DIRECTORY_TREE_LEAF = -1;
var DirectoryTree = /*#__PURE__*/function () {
  "use strict";

  function DirectoryTree(doc) {
    _classCallCheck(this, DirectoryTree);
    this._doc = doc;
  }
  _createClass(DirectoryTree, [{
    key: "load",
    value: function load(secIds) {
      var _this = this;
      var doc = this._doc;
      return doc._readSectors(secIds).then(function (buffer) {
        var count = buffer.length / 128;
        _this._entries = new Array(count);
        for (var i = 0; i < count; i++) {
          var offset = i * 128;
          var nameLength = Math.max(buffer.readInt16LE(64 + offset) - 1, 0);
          var entry = {};
          entry.name = buffer.toString('utf16le', 0 + offset, nameLength + offset);
          entry.type = buffer.readInt8(66 + offset);
          entry.nodeColor = buffer.readInt8(67 + offset);
          entry.left = buffer.readInt32LE(68 + offset);
          entry.right = buffer.readInt32LE(72 + offset);
          entry.storageDirId = buffer.readInt32LE(76 + offset);
          entry.secId = buffer.readInt32LE(116 + offset);
          entry.size = buffer.readInt32LE(120 + offset);
          _this._entries[i] = entry;
        }
        _this.root = _this._entries.find(function (entry) {
          return entry.type === DIRECTORY_TREE_ENTRY_TYPE_ROOT;
        });
        _this._buildHierarchy(_this.root);
      });
    }
  }, {
    key: "_buildHierarchy",
    value: function _buildHierarchy(storageEntry) {
      var childIds = this._getChildIds(storageEntry);
      storageEntry.storages = {};
      storageEntry.streams = {};
      var _iterator = _createForOfIteratorHelper(childIds),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var childId = _step.value;
          var childEntry = this._entries[childId];
          var _name = childEntry.name;
          if (childEntry.type === DIRECTORY_TREE_ENTRY_TYPE_STORAGE) {
            storageEntry.storages[_name] = childEntry;
          }
          if (childEntry.type === DIRECTORY_TREE_ENTRY_TYPE_STREAM) {
            storageEntry.streams[_name] = childEntry;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var name in storageEntry.storages) {
        this._buildHierarchy(storageEntry.storages[name]);
      }
    }
  }, {
    key: "_getChildIds",
    value: function _getChildIds(storageEntry) {
      var _this2 = this;
      var childIds = [];
      var visit = function visit(visitEntry) {
        if (visitEntry.left !== DIRECTORY_TREE_LEAF) {
          childIds.push(visitEntry.left);
          visit(_this2._entries[visitEntry.left]);
        }
        if (visitEntry.right !== DIRECTORY_TREE_LEAF) {
          childIds.push(visitEntry.right);
          visit(_this2._entries[visitEntry.right]);
        }
      };
      if (storageEntry.storageDirId > -1) {
        childIds.push(storageEntry.storageDirId);
        var rootChildEntry = this._entries[storageEntry.storageDirId];
        visit(rootChildEntry);
      }
      return childIds;
    }
  }]);
  return DirectoryTree;
}();
module.exports = DirectoryTree;